module.exports = __webpack_public_path__ + "img/reloj-arena.32162540.svg";